export const invocieAttributes = [
    "id",
    "invoice_due",
    "invoice_source",
    "created_at",
    "invoice_amount",
    "invoice_status",
    "invoice_number",
    "parent_user",
    "attempted",
    "updated_at",
    "payment_type",
    "transaction_comment",
    "invoice_pdf_link",
    "customer_first_name",
    "customer_last_name",
    "customer_phone",
    "customer_email",
    "scheduled_date",
    "bank_transfer",
    "collect_payments",
    "wisetack_transaction",
    "attachments",
]

export const paymentHistoryAttributes = [
    "id",
    "paid_amount",
    "tip",
    "reference_number",
    "payment_method",
    "payment_using",
    "payment_type",
    "source",
    "status",
    "orderid",
    "token",
    "user",
    "updated_at",
    "invoice_url",
    "created_at",
    "product",
    "paid_date",
    "is_google_pay"
]

